
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[campaign]/auth/register",
      function () {
        return require("private-next-pages/[campaign]/auth/register.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[campaign]/auth/register"])
      });
    }
  